import React from 'react';

const BlogShare = (blogURL) => {
  return (
    <div class="row align-items-center">
      <div class="col-lg-6 col-sm-6">
        <div class="blog-sheare-tag">
          <ul>
            <li>Share</li>
          </ul>
        </div>
      </div>

      <div class="col-lg-6 col-sm-6">
        <ul class="social-icon">
          <li>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${blogURL.blogURL}`} target="_blank" rel="noreferrer">
              <i class="bx bxl-facebook"></i>
            </a>
          </li>
          <li>
            <a href={`https://twitter.com/intent/tweet?url=${blogURL.blogURL}`} target="_blank" rel="noreferrer">
              <i class="bx bxl-twitter"></i>
            </a>
          </li>
          <li>
            <a href={`https://www.instagram.com/explore/tags/${blogURL.blogURL}`} target="_blank" rel="noreferrer">
              <i class="bx bxl-instagram"></i>
            </a>
          </li>
          <li>
            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${blogURL.blogURL}`} target="_blank" rel="noreferrer">
              <i class="bx bxl-linkedin"></i>
            </a>
          </li>
          <li>
            <a href={`https://www.youtube.com/share?url=${blogURL.blogURL}`} target="_blank" rel="noreferrer">
              <i class="bx bxl-youtube"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BlogShare;